import './../../scss/theme/plugins/newslist.scss';

const newsSearchForm = document.querySelector('.news-search-form');

if(newsSearchForm) {
  const searchForm = newsSearchForm.querySelector('form'),
    searchTopics = newsSearchForm.querySelectorAll('.news-search-topics a'),
    searchInput = newsSearchForm.querySelector('.form-control'),
    searchReset = document.querySelector('.news-list-view_reset-search'),
    submitBtn = newsSearchForm.querySelector('.btn'),
    errorMsg = newsSearchForm.querySelector('.error-msg');

  // Submit with empty input
  submitBtn?.addEventListener('click', (e) => {
    if(!searchInput.value?.length) {
      e.preventDefault();
      errorMsg.removeAttribute('hidden');
      searchInput.classList.add('error');
      searchInput.focus();
      //if input is typed, remove error message
      searchInput.addEventListener('input', () => {
        errorMsg.setAttribute('hidden', '');
        searchInput.removeClass('error');
      }, {once: true});
    }
  });
  // Tag-Search
  searchTopics?.forEach((searchTopic) => {
    searchTopic.addEventListener('click', (e) => {
      e.preventDefault();
      searchInput.value = searchTopic.getAttribute('data-term');
      searchForm.submit();
    });
  });
  // Reset-Search
  searchReset?.addEventListener('click', (e) => {
    e.preventDefault();
    searchInput.value = '';
    searchForm.submit();
  });
}
